import debug from 'bows';
import Dropdown from 'modernDropdown';
import breakpoints from '../_breakpoints';

const log = debug('hero');

class Hero {
	constructor(node) {
		this.node = node;

		if (this.node.classList.contains('flex-layout--hero--has-nav')) {
			this.dropdowns = Array.prototype.slice.call(this.node.querySelectorAll('.nav__menu-item--depth0.nav__menu-item--has-submenu')).map((item) => {
				const layout = this.node;
				return new Dropdown(item, {
					openClass: 'nav__menu-item--submenu-open',
					menu: '.nav__menu',
					beforeOpen: () => {
						if (document.body.clientWidth < breakpoints.medium) {
							return false;
						}


					},
					afterOpen: function() {
						if (document.body.clientWidth < breakpoints.medium) {
							return;
						}

						if (layout.getBoundingClientRect().right < this.menu.getBoundingClientRect().right) {
							this.menu.classList.add('nav__menu--off-right');
						}


						let browserHeight = isNaN(window.innerHeight) ? window.clientHeight : window.innerHeight;
						let menuHeight = item.clientHeight + this.menu.clientHeight;
						if ((browserHeight - (item.getBoundingClientRect().top + menuHeight) < 10)) {
							this.menu.style.top = 'auto';
							this.menu.style.bottom = (item.clientHeight - 2) + 'px';
							this.menu.classList.add('nav__menu--off-top');
						}

					},
					afterClose: function() {
						if (this.menu.classList.contains('nav__menu--off-right')) {
							this.menu.classList.remove('nav__menu--off-right');
						}

						if (this.menu.classList.contains('nav__menu--off-top')) {
							this.menu.classList.remove('nav__menu--off-top');
						}

						this.menu.removeAttribute('style');
					}
				});
			});

			this.subMenuToggles = Array.prototype.slice.call(this.node.querySelectorAll('.nav__menu-item--has-submenu > .nav__link'));
			if (this.subMenuToggles.length) {
				this.subMenuToggles.forEach((t) => {
					t.addEventListener('click', (e) => {
						if (document.body.clientWidth < breakpoints.medium) {
							if (!t.parentNode.classList.contains('nav__menu-item--submenu-open')) {
								e.preventDefault();
								t.parentNode.classList.add('nav__menu-item--submenu-open');
							} else {
								window.location.href = t.href;
							}
						}
					});
				});
			}

			this.menuToggle = this.node.querySelector('a[href="#menu-toggle"]');
			if (this.menuToggle) {
				this.menuToggle.addEventListener('click', (e) => {
					e.preventDefault();
					this.node.classList.toggle('flex-layout--hero--nav-open');
				});
			}
		}

		if (this.node.dataset.video) {
			this.video = document.createElement('video');
			this.video.type = (this.node.dataset.videoMimeType) ? this.node.dataset.videoMimeType : 'video/mp4';

			if (this.video.canPlayType(this.video.type)) {
				this.video.classList.add('hero__video');
				this.video.src = this.node.dataset.video;
				this.video.volume = 0;
				this.video.muted = true;
				this.video.loop = true;
				this.video.setAttribute('playsinline', 'playsinline');

				let poster = getComputedStyle(node).backgroundImage;
				if ( poster ) {
					poster = poster.replace( /^url\(['"]/, '').replace( /['"]\)$/, '' );
					this.video.poster = poster;
				}

				const wrap = this.node.querySelector('.flex-layout__wrap');
				wrap.insertBefore(this.video, wrap.firstChild);

				let promise = this.video.play();

				if ( typeof promise !== 'undefined' ) {
					promise.then(() => {
						this.video.insertAdjacentHTML('afterend', '<div class="hero__overlay"></div>');
						log('video autoplay');
					}).catch(() => {
						log("video can't autoplay");
						this.video.parentNode.removeChild(this.video);
					});
				} else {
					let onTimeUpdate = () => {
						log('timeupdate');
						this.video.insertAdjacentHTML('afterend', '<div class="hero__overlay"></div>');
						this.video.removeEventListener('timeupdate', onTimeUpdate);
					}

					this.video.addEventListener('timeupdate', onTimeUpdate);
				}
			}
		}
	}
}

export default Hero;
